// Username generator utility for creating friendly names like "Purple Tiger" or "Angry Zebra"

const adjectives = [
  'Brave', 'Swift', 'Mighty', 'Clever', 'Silent', 'Golden', 'Silver', 'Wild', 'Free', 'Bold',
  'Gentle', 'Fierce', 'Noble', 'Quick', 'Bright', 'Dark', 'Wise', 'Strong', 'Lucky', 'Happy',
  'Angry', 'Calm', 'Eager', 'Proud', 'Shy', 'Loud', 'Quiet', 'Fast', 'Slow', 'Tall',
  'Small', 'Big', 'Tiny', 'Huge', 'Sharp', 'Smooth', 'Rough', 'Soft', 'Hard', 'Light'
];

const colors = [
  'Red', 'Blue', 'Green', 'Yellow', 'Purple', 'Orange', 'Pink', 'Black', 'White', 'Gray',
  'Brown', 'Cyan', 'Magenta', 'Lime', 'Navy', 'Teal', 'Silver', 'Gold', 'Crimson', 'Azure',
  'Violet', 'Indigo', 'Coral', 'Salmon', 'Turquoise', 'Emerald', 'Ruby', 'Amber', 'Jade', 'Pearl'
];

const animals = [
  'Tiger', 'Lion', 'Eagle', 'Wolf', 'Bear', 'Fox', 'Deer', 'Rabbit', 'Hawk', 'Owl',
  'Elephant', 'Giraffe', 'Zebra', 'Leopard', 'Cheetah', 'Panda', 'Koala', 'Kangaroo', 'Penguin', 'Dolphin',
  'Shark', 'Whale', 'Octopus', 'Turtle', 'Falcon', 'Raven', 'Swan', 'Peacock', 'Butterfly', 'Dragonfly',
  'Horse', 'Unicorn', 'Dragon', 'Phoenix', 'Griffin', 'Jaguar', 'Lynx', 'Panther', 'Mongoose', 'Meerkat',
  'Badger', 'Otter', 'Seal', 'Walrus', 'Moose', 'Elk', 'Rhino', 'Hippo', 'Crocodile', 'Lizard'
];

/**
 * Generates a random username combining an adjective/color with an animal name
 * @param {string} seed - Optional seed for consistent generation (like peer ID)
 * @returns {string} Generated username like "Purple Tiger" or "Brave Eagle"
 */
export function generateUsername(seed = null) {
  let randomSeed;
  
  if (seed) {
    // Create a simple hash from the seed for consistent results
    randomSeed = seed.split('').reduce((acc, char) => {
      return acc + char.charCodeAt(0);
    }, 0);
  } else {
    randomSeed = Math.floor(Math.random() * 1000000);
  }
  
  // Use the seed to pick consistent indices
  const useColor = randomSeed % 2 === 0; // 50% chance for color vs adjective
  
  let firstWord;
  if (useColor) {
    const colorIndex = randomSeed % colors.length;
    firstWord = colors[colorIndex];
  } else {
    const adjectiveIndex = randomSeed % adjectives.length;
    firstWord = adjectives[adjectiveIndex];
  }
  
  // Use a different calculation for animal to ensure variety
  const animalIndex = (randomSeed * 7 + 13) % animals.length;
  const animal = animals[animalIndex];
  
  return `${firstWord} ${animal}`;
}

/**
 * Generates a completely random username without any seed
 * @returns {string} Random username
 */
export function generateRandomUsername() {
  return generateUsername();
}

/**
 * Generates a username based on peer ID for consistency
 * @param {string} peerId - The peer ID to use as seed
 * @returns {string} Consistent username for the given peer ID
 */
export function generateUsernameFromPeerId(peerId) {
  if (!peerId) {
    return generateRandomUsername();
  }
  return generateUsername(peerId);
}
